export default "__VITE_ASSET__5gnZtlcd__"